import * as actionTypes from './actionTypes';

export const mapVeteranNextStep = () => {
  return {
    type : actionTypes.MAP_VETERAN_NEXT_STEP,
    val : null
  }
}

export const mapVeteranGoBack = () => {
  return {
    type : actionTypes.MAP_VETERAN_PREVIOUS_STEP,
    val : null
  }
}

export const mapVeteranUploadFileSuccess = (columns, data, file) => {
  console.log(columns, data, file)
  return {
    type : actionTypes.MAP_VETERAN_UPLOAD_FILE_SUCCESS,
    val : {
      columns : columns,
      data : data,
      file: file
    }
  }
}

export const mapVeteranMatchColumnSuccess = (val) => {
  return {
    type : actionTypes.MAP_VETERAN_MATCH_COLUMN_SUCCESS,
    val : val
  }
}

export const saveAllVeteranMapping = (val) => {
  return {
    type : actionTypes.MAP_VETERAN_SAVE_VETERAN_MAPPING,
    val : val
  }
}

export const resetVeteran = () => {
  return {
    type : actionTypes.MAP_VETERAN_RESET,
    val : null
  }
}

export const resetMapVeteranStep = () => {
  return {
    type : actionTypes.MAP_VETERAN_RESET_STEP,
    val : null
  }
}
